{
  "createFarmAddress_line_1": {
    "label": "Address Line 1",
    "placeholder": "(Enter Farm Address)"
  },
  "createFarmAddress_line_2": {
    "label": "Address Line 2",
    "placeholder": ""
  },
  "createFarmCity": {
    "label": "City",
    "placeholder": "(Enter City)"
  },
  "createFarmCountry": {
    "label": "Country",
    "placeholder": "(Choose Country)"
  },
  "createFarmDescription": "Otherwise, if you are the first user at your farm, you can create a farm account.  After, you can invite other users to join your farm.",
  "createFarmHelpTitle": "About Farm Accounts",
  "createFarmLinkTo": "New Farm Account",
  "createFarmName": {
    "label": "Name",
    "placeholder": "(Enter Farm Name)"
  },
  "createFarmPostalCode": {
    "label": "Postal Code",
    "placeholder": "(Enter Postal Code)"
  },
  "createFarmRegion": {
    "label": "Region",
    "placeholder": "(Choose Region)"
  },
  "createFarmTitle": "New Farm Account",
  "createNewFarmAccount": "Create a new farm account",
  "enterFarmJoinCode": "Enter Farm Join Code",
  "enterYourFarmAddress": "Enter your farm's address",
  "farmAccountHelpBodyText": "Your farm account is a representation of a real-life farm, which serves as a hub for all of the following:\n\nDevices: Your devices monitor pieces of irrigation equipment using a variety of sensors.\n\nFields: Fields give context to device status updates and aggregate irrigation data based on the activity within their boundaries.\n\nUsers: Allows farm managers and employees to interact with the FarmHQ system.\n\nYour farm account(s) are distinct from your user account in a few important ways. There is no login information to remember - instead, when you sign in to to farmhq.com with your personal credentials, your farm's devices and fields will be loaded automatically.\n\nQ: Can I join more than one farm account?\n\nA: Yes. Once you are a member of a farm, you can navigate to and join or create another farm.",
  "farmAccountHelpTitle": "About Farm Accounts",
  "farmJoinCodeLabel": "Farm Join Code",
  "ifAnotherUserHasAlreadyCreatedYourFarmAccount": "If someone at your farm already created a farm account, they can give you a Farm Join Code. You can use that code to link your user account to the farm account.",
  "instructions": "Next, you must connect to a farm account.",
  "joinFarmAlreadyJoined": "You are already a member of this farm account.",
  "joinFarmDescription": "If someone at your farm already created a farm account, they can give you a Farm Join Code.\n\nConnect your user account to the farm account by entering the code below:",
  "joinFarmLinkTo": "Join Another Farm Account",
  "joinFarmTitle": "Join Farm With Code",
  "joinFarmWithCode": "Join Farm With Code",
  "joinFarmWithCodeHelpBodyText": "Farm Join Codes allow users to link their user account to a farm account. By joining a farm account, users are able to view and manage all of the devices that are associated with that farm.\n\nFarm Join Codes are unique 6-character codes that are generated by the farm owner. If you are a user that has been given a Farm Join Code, you can enter it here to join the farm account.\n\nThe user that created the code must also decide what permission you will have on the farm account. This will determine what actions you can take on the farm account.",
  "joinFarmWithCodeHelpTitle": "About Farm Join Codes",
  "newFarmAccount": "New Farm Account",
  "noFarmsTitle": "No Farms",
  "successAddDevices": {
    "description": "Register your FarmHQ devices",
    "text": "Add Devices"
  },
  "successDrawFields": {
    "description": "Draw your farms fields",
    "text": "Draw Fields"
  },
  "successInstructions": "Here are some of the ways you can get started with FarmHQ",
  "successTitle": "Success",
  "successViewSupport": {
    "description": "Explore our support documentation",
    "text": "Support"
  },
  "userAccountCreatedMessage": "User Account Created",
  "welcomeToFarmHQ": "Welcome to FarmHQ",
  "whatWeUseFarmLocationForText": "We use this information to make sure our map-based features work correctly. We do not share this information with any third parties.",
  "whatWeUseFarmLocationForTitle": "Farm Address Collection"
}
